<ng-container *ngIf="!item.hidden">
  <li class="nav-item pcoded-menu-caption"><label>{{item.title}}</label></li>
  <ng-container *ngFor="let item of item.children">
    <app-user-nav-group *ngIf="item.type=='group'" [item]="item"></app-user-nav-group>
    <app-user-nav-collapse *ngIf="item.type=='collapse'" [item]="item"></app-user-nav-collapse>
    <app-user-nav-item *ngIf="item.type=='item'" [item]="item"></app-user-nav-item>
  </ng-container>
</ng-container>